export const actionTypes = {
    DEVICE_INFORMATION: "DEVICE_INFORMATION"

  };
  
  export function deviceDetails(payload) {
    return { type: actionTypes.DEVICE_INFORMATION, payload };
  }
